<!-- <div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
      <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div> -->
<div class="container-fluid">
  <div class="card shadow">
    <div class="card-header">
      <div class="d-flex justify-content-between">
        <h4 class="font-weight-bold text-dark py text-center">List of Winners</h4>
      </div>
    </div>
    <div class="wrapper">
      <div class="card-body">
        <div class="form-group row">
          <div class="col-sm-6 mb-3 mb-sm-0">
            <label>Party District / கட்சி மாவட்டம்<span class="required "> *</span></label><br>
            <!-- <select class="form-control"  [(ngModel)]="district" (click)="Constituency_selection(district)">
                                <option value="" selected disabled hidden>Select District</option>
                                <option *ngFor="let option of district_list" (value)="option" >
                                {{option}}</option>
                            </select> -->
            <input type="text" name="district" [(ngModel)]="district" class="form-control"
              placeholder="Party District / கட்சி மாவட்டம்" readonly="readonly"  />
          </div>
          <div class="col-sm-6">
            <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required "> *</span></label><br>
            <select class="form-control" [(ngModel)]="constituency" (change)="Constituency_selection(constituency)">
              <option value="" selected disabled hidden >Select constituency</option>
              <option *ngFor="let option of user_constituency" [value]="option">{{option}}</option>
            </select>
            <div class="invalid-msg" *ngIf="!constituency" [hidden]='hidden'>Select Constituency</div>

          </div>
        </div>
        <form [formGroup]="winnerform" (ngSubmit)="postdata()" autocomplete="off">
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>No of Participants / பங்கேற்பாளர்களின் எண்ணிக்கை<span class="required">*</span></label>
              <input type="text" name="no_of_participants" class="form-control"
                placeholder="No of Participants / பங்கேற்பாளர்களின் எண்ணிக்கை" formControlName="no_of_participants" />

              <!-- Display validation error message if the field is touched and invalid -->
              <div
                *ngIf="winnerform.get('no_of_participants').touched && winnerform.get('no_of_participants').hasError('required')"
                class="invalid-msg">
                Please fill this field
              </div>

              <div
                *ngIf="winnerform.get('no_of_participants').touched && winnerform.get('no_of_participants').hasError('pattern')"
                class="invalid-msg">
                Please enter a valid number
              </div>

              <div class="invalid-msg" *ngIf="winnerform.get('no_of_participants').untouched" [hidden]='hidden'>Please
                fill this field</div>

            </div>

            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Date of Competition / போட்டி தேதி<span class="required">*</span></label>
              <input type="date" name="date_of_compertition" class="form-control"
                formControlName="date_of_compertition" />
              <div
                *ngIf="winnerform.get('date_of_compertition').touched && winnerform.get('date_of_compertition').hasError('required')"
                class="invalid-msg">
                Please fill this field
              </div>
              <div class="invalid-msg" *ngIf="winnerform.get('date_of_compertition').untouched" [hidden]='hidden'>Please
                fill this field</div>
            </div>

          </div>

          <div class="form-group row">
            <label>Venue of the Competition / போட்டி நடைபெற்ற இடம்<span class="required">*</span></label>
            <textarea name="venue" class="form-control" placeholder="Venue of the Competition / போட்டி நடைபெற்ற இடம்"
              formControlName="venue"></textarea>
            <div *ngIf="winnerform.get('venue').touched && winnerform.get('venue').hasError('required')"
              class="invalid-msg">
              Please fill this field
            </div>



            <div class="invalid-msg" *ngIf="winnerform.get('venue').untouched" [hidden]='hidden'>Please fill this field
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Photo 1<span class="required "> *</span></label>
              <input type="file" name="images1" class="form-control" accept="image/*"
                (change)="onFileChange($event, 'images1')">

              <div *ngIf="!imageSrc1" class="invalid-msg" [hidden]='hidden'>Please fill out this field
              </div>
              <div *ngIf="fileFormatStatus1" class="invalid-msg">
                Only allowed extensions are .png .jpeg .jpg</div>
              <div *ngIf="fileSizeStatus1" class="invalid-msg">
                Maximum allowed file size is 1MB</div>
                <div class="form-group row">
                  <div class="col-sm-12 mb-3 mb-sm-0"> <a href="https://jpeg-optimizer.com/compress-jpeg-to-90kb/" target="_blank" >Click here to  compress your photos</a></div>

                </div>
            </div>


            <img [src]="imageSrc1" *ngIf="imageSrc1" style="height: 190px; width:160px; border: 1px solid #555; ">


            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Photo 2<span class="required "> *</span></label>
              <input type="file" name="images2" class="form-control" accept="image/*"
                (change)="onFileChange($event, 'images2')">
              <div *ngIf="!imageSrc2" class="invalid-msg" [hidden]='hidden'>Please fill out this field
              </div>
              <div *ngIf="fileFormatStatus2" class="invalid-msg">
                Only allowed extensions are .png .jpeg .jpg</div>
              <div *ngIf="fileSizeStatus2" class="invalid-msg">
                Maximum allowed file size is 1MB</div>
            </div>


            <img [src]="imageSrc2" *ngIf="imageSrc2" style="height: 190px; width:160px; border: 1px solid #555; ">

          </div>
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Photo 3<span class="required "> *</span></label>
              <input type="file" name="images3" class="form-control" accept="image/*"
                (change)="onFileChange($event, 'images3')">
              <div *ngIf="!imageSrc3" class="invalid-msg" [hidden]='hidden'>Please fill out this field
              </div>
              <div *ngIf="fileFormatStatus3" class="invalid-msg">
                Only allowed extensions are .png .jpeg .jpg</div>
              <div *ngIf="fileSizeStatus3" class="invalid-msg">
                Maximum allowed file size is 1MB</div>
            </div>


            <img [src]="imageSrc3" *ngIf="imageSrc3" style="height: 190px; width:160px; border: 1px solid #555; ">


            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Photo 4<span class="required "> *</span></label>
              <input type="file" name="images4" class="form-control" accept="image/*"
                (change)="onFileChange($event, 'images4')">
              <div *ngIf="!imageSrc4" class="invalid-msg" [hidden]='hidden'>Please fill out this field
              </div>
              <div *ngIf="fileFormatStatus4" class="invalid-msg">
                Only allowed extensions are .png .jpeg .jpg</div>
              <div *ngIf="fileSizeStatus4" class="invalid-msg">
                Maximum allowed file size is 1MB</div>
            </div>


            <img [src]="imageSrc4" *ngIf="imageSrc4" style="height: 190px; width:160px; border: 1px solid #555; ">

          </div>
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Photo 5<span class="required "> *</span></label>
              <input type="file" name="images5" class="form-control" accept="image/*"
                (change)="onFileChange($event, 'images5')">
              <div *ngIf="!imageSrc5" class="invalid-msg" [hidden]='hidden'>Please fill out this field
              </div>
              <div *ngIf="fileFormatStatus5" class="invalid-msg">
                Only allowed extensions are .png .jpeg .jpg</div>
              <div *ngIf="fileSizeStatus5" class="invalid-msg">
                Maximum allowed file size is 1MB</div>
            </div>


            <img [src]="imageSrc5" *ngIf="imageSrc5" style="height: 190px; width:160px; border: 1px solid #555; ">

          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-hover" id="tab_logic">

              <thead>
                <tr>
                  <th class="text-center" colspan="10">Winners Details</th>
                </tr>
                <tr>
                  <th class="text-center">S.No</th>
                  <th class="text-center">Positions</th>
                  <th class="text-center">Register No</th>
                  <th class="text-center">Name</th>
                  <th class="text-center">College Name</th>
                  <th class="text-center">Phone No</th>
                  <th class="text-center">Topics</th>
                  <th class="text-center">Photo</th>
                  <th class="text-center">Actions</th>

                </tr>
              </thead>
              <tbody id="table-body" formArrayName="winners">
                <ng-container *ngFor="let winner of winnersArray().controls; let i = index">
                  <tr [formGroupName]="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <select name="position" formControlName="position" class="form-control">
                        <option value="">Select Option</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                      </select>
                      <div
                        *ngIf="winnerform.get('winners.' + i + '.position').touched && winnerform.get('winners.' + i + '.position').hasError('required')"
                        class="invalid-msg">
                        Position is required
                      </div>
                      <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.position').untouched"
                        [hidden]='hidden'>Please fill this field</div>

                    </td>
                    <td>
                      <input type="text" name="register_number" formControlName="register_number"
                        placeholder="Register No" class="form-control" />
                      <div
                        *ngIf="winnerform.get('winners.' + i + '.register_number').touched && winnerform.get('winners.' + i + '.register_number').hasError('required')"
                        class="invalid-msg">
                        Register number is required
                      </div>
                      <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.register_number').untouched"
                        [hidden]='hidden'>Please fill this field</div>

                    </td>
                    <td>
                      <input type="text" name="student_name" formControlName="student_name" placeholder="Student Name"
                        class="form-control input-sm" />
                      <div
                        *ngIf="winnerform.get('winners.' + i + '.student_name').touched && winnerform.get('winners.' + i + '.student_name').hasError('required')"
                        class="invalid-msg">
                        Student number is required
                      </div>
                      <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.student_name').untouched"
                        [hidden]='hidden'>Please fill this field</div>

                    </td>
                    <td>
                      <input type="text" name="college_name" formControlName="college_name" placeholder="College Name"
                        class="form-control input-sm" />
                      <div
                        *ngIf="winnerform.get('winners.' + i + '.college_name').touched && winnerform.get('winners.' + i + '.college_name').hasError('required')"
                        class="invalid-msg">
                        College Name is required
                      </div>
                      <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.college_name').untouched"
                        [hidden]='hidden'>Please fill this field</div>

                    </td>
                    <td>
                      <input type="text" name="mobile_number" formControlName="mobile_number" maxlength="10"
                        placeholder="Mobile No" class="form-control" />
                      <div
                        *ngIf="winnerform.get('winners.' + i + '.mobile_number').touched && winnerform.get('winners.' + i + '.mobile_number').hasError('required')"
                        class="invalid-msg">
                        Mobile Number is required
                      </div>
                      <div *ngIf="winnerform.get('winners.' + i + '.mobile_number').hasError('pattern')"
                        class="invalid-msg">
                        Mobile Number is invalid
                      </div>
                      <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.mobile_number').untouched"
                        [hidden]='hidden'>Please fill this field</div>

                    </td>
                    <td>
                      <select name="topic" formControlName="topic" class="form-control">
                        <option value="">Select Option</option>
                        <option value="தொழில்நுட்பக் கல்விக்கு தோள் கொடுத்த கலைஞர்">தொழில்நுட்பக் கல்விக்கு தோள் கொடுத்த
                          கலைஞர்</option>
                        <option value="தொழில்துறையை உயர்த்திய தமிழினத் தலைவர்">தொழில்துறையை உயர்த்திய தமிழினத் தலைவர்
                        </option>
                        <option value="திராவிட மாடலும் திறன்மிக்கக் கல்வியும்">திராவிட மாடலும் திறன்மிக்கக் கல்வியும்
                        </option>
                        <option value="தெற்குச்சூரியன்">தெற்குச்சூரியன்</option>
                        <option value="கலைஞரும் தமிழும்">கலைஞரும் தமிழும்</option>
                      </select>
                      <div
                        *ngIf="winnerform.get('winners.' + i + '.topic').touched && winnerform.get('winners.' + i + '.topic').hasError('required')"
                        class="invalid-msg">
                        Topic is required
                      </div>
                      <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.topic').untouched"
                        [hidden]='hidden'>Please fill this field</div>

                    </td>
                    <td>
                      <div class="form-group">

                        <input formControlName="photo" type="file" name="photo"
                          (change)="onImageArray($event, 'create', i)" class="form-control" accept="image/*" />
                        <div
                          *ngIf="winnerform.get('winners.' + i + '.photo').touched && winnerform.get('winners.' + i + '.photo').hasError('required')"
                          class="invalid-msg">
                          photo is required
                        </div>
                        <div class="invalid-msg" *ngIf="winnerform.get('winners.' + i + '.photo').untouched"
                          [hidden]='hidden'>Please fill this field</div>
                          <!-- <div *ngIf="!imageSrc[i]" class="invalid-msg" [hidden]='hidden'>Please fill out this field
                          </div> -->
                          <div *ngIf="fileFormatStatuss[i] === 0"  class="invalid-msg">
                            Only allowed extensions are .png .jpeg .jpg</div>
                          <div *ngIf="fileSizeStatuss[i] === 0" class="invalid-msg">
                            Maximum allowed file size is 1MB</div>



                        <div *ngIf="winnerImages[i] != null" class="invalid-msg">Selected Image:</div>
                        <img [src]="winnerImages[i]" *ngIf="winnerImages[i]" style="max-width: 50%;" />
                      </div>


                    </td>
                    <td>
                      <button *ngIf="i > 0" type="button" class="btn btn-danger" (click)="removeRow(i)"><i
                          class="fas fa-trash"></i></button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>

            </table>
          </div>

          <!-- Button to add a new row -->
          <button type="button" class="btn btn-primary" (click)="addRow()">Add Row</button>

          <div class="d-flex justify-content-center">
            <div style="width: 200px">
              <button class="btn btn-danger btn btn-block" data-toggle="modal" data-target="#message"
                data-backdrop="false" [hidden]='isButtonVisible'>
                Save Winners List
              </button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>